import {useEffect} from "react";
import {Outlet, useLocation} from "react-router";
import {getPageTitle} from "src/getNavigation";
import {capitalize} from "src/utils";

const getBaseDomain = (hostname: string): string => {
  const parts = hostname.split(".");

  // admin.<domain>.<TLD> -> take the second part (domain)
  // admin.betkumi.com -> betkumi
  // admin.betkumi.co.ke -> betkumi
  return parts[1];
};

const AppTitle = () => {
  const {pathname} = useLocation();
  const baseDomain = capitalize(getBaseDomain(window.location.hostname));

  useEffect(() => {
    // Remove leading slash and get page title from navigation data
    const pathSegment = pathname.slice(1);
    const pageTitle = getPageTitle(pathSegment);

    document.title = pageTitle ? `${baseDomain} | ${pageTitle}` : baseDomain;
  }, [pathname, baseDomain]);

  return null;
};

const GlobalLayout = () => {
  return (
    <>
      <AppTitle />
      <Outlet />
    </>
  );
};

export default GlobalLayout;
